__turbopack_context__.v({
  "Grey": "Section-module-scss-module__NOCk5q__Grey",
  "NoPadding": "Section-module-scss-module__NOCk5q__NoPadding",
  "NoPaddingTop": "Section-module-scss-module__NOCk5q__NoPaddingTop",
  "Section": "Section-module-scss-module__NOCk5q__Section",
});
